import { useSelector } from "react-redux";


const selectShowPreview = state => state.ui.preview
export function useShowPreview () {
    return useSelector(selectShowPreview)
}